<!-- eslint-disable -->
<template>
  <transition name="crm-modal-fade">
    <div
      v-if="visible"
      class="crm-modal-backdrop"
      @mousedown.self="$emit('close')"
    >
      <div class="crm-modal-card crm-decision-modal">
        <!-- Header -->
        <div class="crm-modal-header">
          <div class="crm-modal-header__left">
            <div class="crm-modal-header__icon">
              <feather-icon icon="CheckCircleIcon" size="18" />
            </div>
            <div>
              <h3 class="crm-modal-header__title">Log Renewal Outcome</h3>
              <p class="crm-modal-header__subtitle" v-if="card">{{ card.title }}</p>
            </div>
          </div>
          <button class="crm-modal-close" @click="$emit('close')">
            <feather-icon icon="XIcon" size="18" />
          </button>
        </div>

        <!-- Body -->
        <div class="crm-modal-body">
          <!-- Decision Buttons -->
          <div class="crm-decision-buttons">
            <button
              class="crm-decision-btn crm-decision-btn--renewed"
              :class="{ 'crm-decision-btn--active': selectedStatus === 'renewed' }"
              @click="selectedStatus = 'renewed'"
            >
              <div class="crm-decision-btn__icon">
                <feather-icon icon="CheckCircleIcon" size="24" />
              </div>
              <span class="crm-decision-btn__label">Renewed</span>
              <span class="crm-decision-btn__desc">Certificate was renewed</span>
            </button>
            <button
              class="crm-decision-btn crm-decision-btn--not-renewed"
              :class="{ 'crm-decision-btn--active': selectedStatus === 'not_renewed' }"
              @click="selectedStatus = 'not_renewed'"
            >
              <div class="crm-decision-btn__icon">
                <feather-icon icon="XCircleIcon" size="24" />
              </div>
              <span class="crm-decision-btn__label">Not Renewed</span>
              <span class="crm-decision-btn__desc">Client chose not to renew</span>
            </button>
          </div>

          <!-- Reason -->
          <div class="crm-form-group" v-if="selectedStatus">
            <label class="crm-form-label">Reason</label>
            <select
              class="crm-select"
              v-model="selectedReason"
            >
              <option value="" disabled>Select a reason…</option>
              <option
                v-for="reason in activeReasons"
                :key="reason"
                :value="reason"
              >{{ reason }}</option>
            </select>
          </div>

          <!-- Custom Reason -->
          <div class="crm-form-group" v-if="selectedReason === 'Other'">
            <label class="crm-form-label">Custom Reason</label>
            <input
              type="text"
              class="crm-input"
              v-model="customReason"
              placeholder="Enter custom reason…"
            />
          </div>
        </div>

        <!-- Footer -->
        <div class="crm-modal-footer">
          <button class="crm-btn crm-btn--ghost" @click="$emit('close')">Cancel</button>
          <button
            class="crm-btn"
            :class="selectedStatus === 'renewed' ? 'crm-btn--success' : 'crm-btn--danger'"
            :disabled="!canSubmit"
            @click="handleSubmit"
          >
            <feather-icon icon="CheckIcon" size="15" />
            Confirm Outcome
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/* eslint-disable */
export default {
  name: 'DecisionModal',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    card: {
      type: Object,
      default: null,
    },
    renewedReasons: {
      type: Array,
      required: true,
    },
    notRenewedReasons: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedStatus: '',
      selectedReason: '',
      customReason: '',
    }
  },
  computed: {
    activeReasons() {
      if (this.selectedStatus === 'renewed') return this.renewedReasons
      if (this.selectedStatus === 'not_renewed') return this.notRenewedReasons
      return []
    },
    canSubmit() {
      if (!this.selectedStatus || !this.selectedReason) return false
      if (this.selectedReason === 'Other' && !this.customReason.trim()) return false
      return true
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.selectedStatus = ''
        this.selectedReason = ''
        this.customReason = ''
      }
    },
    selectedStatus() {
      this.selectedReason = ''
      this.customReason = ''
    },
  },
  methods: {
    handleSubmit() {
      if (!this.canSubmit) return
      const reason = this.selectedReason === 'Other' ? this.customReason.trim() : this.selectedReason
      this.$emit('submit', {
        status: this.selectedStatus,
        reason,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
$primary: #6366f1;
$primary-dark: #4f46e5;
$success: #10b981;
$success-dark: #059669;
$warning: #f59e0b;
$danger: #f43f5e;
$danger-dark: #e11d48;
$slate-50: #f8fafc;
$slate-100: #f1f5f9;
$slate-200: #e2e8f0;
$slate-300: #cbd5e1;
$slate-400: #94a3b8;
$slate-500: #64748b;
$slate-600: #475569;
$slate-700: #334155;
$slate-900: #0f172a;

.crm-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1060;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.crm-modal-card {
  background: #fff;
  border-radius: 16px;
  width: 480px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 60px -12px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.crm-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid $slate-100;

  &__left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    background: linear-gradient(135deg, $primary, $primary-dark);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }

  &__title {
    font-family: 'Outfit', 'Inter', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: $slate-900;
    margin: 0;
  }

  &__subtitle {
    font-size: 12.5px;
    color: $slate-500;
    margin: 2px 0 0 0;
  }
}

.crm-modal-close {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: $slate-50;
  color: $slate-400;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: $slate-100;
    color: $slate-600;
  }
}

.crm-modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1;
}

.crm-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid $slate-100;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.crm-decision-buttons {
  display: flex;
  gap: 14px;
  margin-bottom: 24px;
}

.crm-decision-btn {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px 16px;
  border-radius: 14px;
  border: 2px solid $slate-200;
  background: $slate-50;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);

  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.25s;
  }

  &__label {
    font-family: 'Outfit', 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 700;
    transition: color 0.2s;
  }

  &__desc {
    font-size: 11.5px;
    color: $slate-400;
    text-align: center;
    line-height: 1.4;
  }

  &--renewed {
    .crm-decision-btn__icon {
      background: rgba($success, 0.1);
      color: $success;
    }
    .crm-decision-btn__label { color: $slate-700; }

    &.crm-decision-btn--active {
      border-color: $success;
      background: rgba($success, 0.04);
      box-shadow: 0 0 0 3px rgba($success, 0.12);

      .crm-decision-btn__icon {
        background: $success;
        color: #fff;
        box-shadow: 0 4px 12px rgba($success, 0.35);
      }
      .crm-decision-btn__label { color: $success-dark; }
    }
  }

  &--not-renewed {
    .crm-decision-btn__icon {
      background: rgba($danger, 0.1);
      color: $danger;
    }
    .crm-decision-btn__label { color: $slate-700; }

    &.crm-decision-btn--active {
      border-color: $danger;
      background: rgba($danger, 0.04);
      box-shadow: 0 0 0 3px rgba($danger, 0.12);

      .crm-decision-btn__icon {
        background: $danger;
        color: #fff;
        box-shadow: 0 4px 12px rgba($danger, 0.35);
      }
      .crm-decision-btn__label { color: $danger-dark; }
    }
  }

  &:hover:not(&--active) {
    border-color: $slate-300;
    background: #fff;
  }
}

.crm-form-group {
  margin-bottom: 18px;
}

.crm-form-label {
  display: block;
  font-family: 'Outfit', 'Inter', sans-serif;
  font-size: 12.5px;
  font-weight: 600;
  color: $slate-600;
  margin-bottom: 6px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.crm-input {
  font-family: 'Outfit', 'Inter', sans-serif;
  width: 100%;
  border: 1.5px solid $slate-200;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13.5px;
  color: $slate-700;
  background: #fff;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;

  &:focus {
    border-color: $primary;
    box-shadow: 0 0 0 3px rgba($primary, 0.1);
  }
}

.crm-select {
  font-family: 'Outfit', 'Inter', sans-serif;
  width: 100%;
  border: 1.5px solid $slate-200;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13.5px;
  color: $slate-700;
  background: #fff;
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%2394a3b8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    border-color: $primary;
    box-shadow: 0 0 0 3px rgba($primary, 0.1);
  }
}

.crm-btn {
  font-family: 'Outfit', 'Inter', sans-serif;
  font-size: 13.5px;
  font-weight: 600;
  padding: 9px 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    transform: none !important;
  }

  &--ghost {
    background: $slate-50;
    color: $slate-600;
    border: 1.5px solid $slate-200;

    &:hover {
      background: $slate-100;
    }
  }

  &--success {
    background: linear-gradient(135deg, $success, $success-dark);
    color: #fff;
    box-shadow: 0 2px 8px rgba($success, 0.3);

    &:hover:not(:disabled) {
      box-shadow: 0 4px 14px rgba($success, 0.4);
      transform: translateY(-1px);
    }
  }

  &--danger {
    background: linear-gradient(135deg, $danger, $danger-dark);
    color: #fff;
    box-shadow: 0 2px 8px rgba($danger, 0.3);

    &:hover:not(:disabled) {
      box-shadow: 0 4px 14px rgba($danger, 0.4);
      transform: translateY(-1px);
    }
  }
}

.crm-modal-fade-enter-active,
.crm-modal-fade-leave-active {
  transition: opacity 0.25s ease;

  .crm-modal-card {
    transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease;
  }
}

.crm-modal-fade-enter,
.crm-modal-fade-leave-to {
  opacity: 0;

  .crm-modal-card {
    transform: scale(0.95) translateY(10px);
    opacity: 0;
  }
}
</style>
